import subscribeStore from "./subscribeStore";

export default async function(id, loop, midi = 0) {
  return await subscribeStore.downloadLoop(id, loop, midi)
}